import { Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import {
  askConfirmationUpdate,
  cancelReactivate,
  hideReactivateModal,
  reactivatePromo,
  setActionUpdateName
} from 'actions/library/promo'
import styles from './ReactivateModal.css'
import DropdownCalendarPromo from 'components/Fields/ReduxForm/DropdownCalendarPromo'
import PromoTimePicker from '../DetailPromo/PromoForm/PromoConfiguration/PromoTimePicker'
import { change, Field, getFormValues, isPristine, reduxForm } from 'redux-form'
import moment from 'moment'
import { mapKeys, findIndex } from 'lodash'
import { libraryPromoDeleteReactivateDeactivate } from 'mixpanel/library/promo'

class ReactivateModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      daysOfWeek: [
        {name: 'Sunday', isNotDisable: false},
        {name: 'Monday', isNotDisable: false},
        {name: 'Tuesday', isNotDisable: false},
        {name: 'Wednesday', isNotDisable: false},
        {name: 'Thursday', isNotDisable: false},
        {name: 'Friday', isNotDisable: false},
        {name: 'Saturday', isNotDisable: false}
      ]
    }
  }

  componentWillReceiveProps (nextProps) {
    let {formValues} = nextProps
    if (formValues) {
      let {date, days} = formValues
      if (date && days) {
        let newDaysState = this._initialDaysState()
        let diff = this._calculateDateDiff(date.startDate, date.endDate)
        let unBlockedDay = 0
        let checkedDay = 0
        if (diff < 7) {
          for (let i = 0; i <= diff; i++) {
            let currDay = this._getCurrentDay(formValues.date.startDate, i)
            let idx = this._findIndexInDays(currDay, newDaysState)
            newDaysState[idx].isNotDisable = true
            unBlockedDay++
          }
        } else {
          newDaysState.forEach((day, idx) => { newDaysState[idx].isNotDisable = true })
          unBlockedDay = 7
        }
        newDaysState.forEach((day, idx) => {
          if (days[idx]) {
            if (!day.isNotDisable && days[idx].checked) {
              this.props.dispatch(change('reactivateForm', `days[${idx}].checked`, ''))
            } else if (day.isNotDisable && days[idx].checked) {
              checkedDay++
            }
          }
        })
        if (unBlockedDay === checkedDay) {
          this.props.dispatch(change('reactivateForm', 'selectAllDays', true))
        }
      }
    }
  }

  componentDidUpdate (prevProps, prevState) {
    let {formValues} = this.props
    if (formValues) {
      let {date, days} = formValues
      // PERLU BANYAK REFACTOR CODE INI
      if (date && days) {
        let diff = this._calculateDateDiff(date.startDate, date.endDate)
        let newDaysState = this._initialDaysState()
        let unBlockedDay = 0
        let checkedDay = 0
        if (diff < 7) {
          for (let i = 0; i <= diff; i++) {
            let currDay = this._getCurrentDay(date.startDate, i)
            let idx = this._findIndexInDays(currDay, newDaysState)
            newDaysState[idx].isNotDisable = true
            unBlockedDay++
          }
        } else {
          unBlockedDay = 7
          newDaysState.forEach((day, idx) => { newDaysState[idx].isNotDisable = true })
        }
        newDaysState.forEach((day, idx) => {
          if (day.isNotDisable && days[idx].checked) {
            checkedDay++
          }
        })
        if (checkedDay !== unBlockedDay) {
          this.props.dispatch(change('reactivateForm', 'selectAllDays', ''))
        } else {
          this.props.dispatch(change('reactivateForm', 'selectAllDays', true))
        }
      }
    }
  }

  _initialDaysState = () => {
    // nama variable yang sebenernya adalah isNotDisable
    // karena cara kerja logicnya adalah buat semua disabled dulu
    // dan enable tanggal yang berada pada range tersebut
    return [
      {name: 'Sunday', isNotDisable: false},
      {name: 'Monday', isNotDisable: false},
      {name: 'Tuesday', isNotDisable: false},
      {name: 'Wednesday', isNotDisable: false},
      {name: 'Thursday', isNotDisable: false},
      {name: 'Friday', isNotDisable: false},
      {name: 'Saturday', isNotDisable: false}
    ]
  }

  _calculateDateDiff = (startDate, endDate) => {
    return moment(endDate).diff(startDate, 'days')
  }

  _findIndexInDays = (currDay) => {
    let {daysOfWeek} = this.state
    return findIndex(daysOfWeek, (day) => { return day.name === currDay })
  }

  _getCurrentDay = (startDate, iterator) => {
    return moment(startDate).add(iterator, 'days').format('dddd')
  }

  render () {
    let {showReactivateModal, formValues, isPristineForm} = this.props

    let {daysOfWeek} = this.state
    let newDaysState = this._initialDaysState()
    let isAvailable = 0
    let dayCheked = 0
    let diff = 0

    if (formValues && formValues.date && daysOfWeek) {
      diff = moment(formValues.date.endDate).diff(formValues.date.startDate, 'days')
      if (diff < 7) {
        for (let i = 0; i <= diff; i++) {
          let currDay = moment(formValues.date.startDate).add(i, 'days').format('dddd')
          let idx = findIndex(daysOfWeek, (day) => { return day.name === currDay })
          newDaysState[idx].isNotDisable = true
        }
      } else {
        newDaysState.forEach((day, idx) => { newDaysState[idx].isNotDisable = true })
      }
      newDaysState.forEach((day, idx) => {
        isAvailable += day.isNotDisable ? 1 : 0
        dayCheked += formValues.days[idx] && formValues.days[idx].checked ? 1 : 0
      })
    }

    return (<Modal show={showReactivateModal} dialogClassName={`${styles.dialog} modal-dialog`}>
      <Modal.Header>
        <Modal.Title className={styles['title-modal']}>
          Update Promo Time Period
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.wrapper}>
          <form>
            <div className={styles['time-period-wrapper']}>
              <div className='col-sm-12'>
                <div className={`col-sm-3 ${styles['no-padding']}`}>
                  <label className={styles.config}>Select date</label>
                </div>
                <div className={`col-sm-6 ${styles['no-padding']}`}>
                  <Field
                    name='date'
                    component={DropdownCalendarPromo}
                    onChange={this._onChangeDate}
                    updateServerOnChange
                  />
                </div>
                <div className='col-sm-3'>&nbsp;</div>
              </div>

              <div className={`col-sm-12 ${styles['margin-top-20']}`}>
                <div className={`col-sm-3 ${styles['no-padding']}`}>
                  <label className={styles.config}>Select hour</label>
                </div>
                <div className={`col-sm-9 ${styles['no-padding']}`}>
                  <div className={`col-sm-2 ${styles['no-padding']}`}>
                    <Field
                      name='hoursFrom'
                      component={PromoTimePicker}
                      showSecond={false}
                      allowEmpty={false}
                      onChangeValue={(e) => {
                        if (moment(e).isBefore(formValues.hoursTo)) {
                          this.props.dispatch(change('reactivateForm', 'hoursFrom', e))
                        }
                      }}
                    />
                  </div>
                  <div className={`col-sm-1 ${styles['no-padding']} text-center`}>-</div>
                  <div className={`col-sm-2 ${styles['no-padding']}`}>
                    <Field
                      name='hoursTo'
                      component={PromoTimePicker}
                      showSecond={false}
                      allowEmpty={false}
                      onChangeValue={(e) => {
                        if (moment(e).isAfter(formValues.hoursFrom)) {
                          this.props.dispatch(change('reactivateForm', 'hoursTo', e))
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className={`col-sm-12 ${styles['margin-top-10']}`}>
                <div className={`col-sm-3 ${styles['no-padding']}`}>
                  <label className={styles.config}>Select day</label>
                </div>
                <div className={`col-sm-9 ${styles['no-padding']}`}>
                  <div className='checkbox'>
                    <Field
                      name='selectAllDays'
                      id='selectAllDaysReactivate'
                      component='input'
                      type='checkbox'
                      onChange={(e) => {
                        for (let idx = 0; idx < newDaysState.length; idx++) {
                          if (newDaysState[idx].isNotDisable) {
                            this.props.dispatch(change('reactivateForm', `days[${idx}].checked`, !e.target.value))
                          }
                        }
                      }}
                    />
                    <label htmlFor='selectAllDaysReactivate'>
                      {isAvailable !== dayCheked ? 'Select All' : 'Unselect All'}
                    </label>
                  </div>
                  {newDaysState.map((day, index) => {
                    return (<div className='checkbox'>
                      <Field
                        key={index}
                        name={`days[${index}].checked`}
                        type='checkbox'
                        component='input'
                        className='pull-left'
                        id={`reactivateDays[${index}]`}
                        disabled={!day.isNotDisable}
                        onChange={(e) => {
                          this.props.dispatch(change('reactivateForm', `days[${index}].name`, day.name))
                          this.props.dispatch(change('reactivateForm', 'selectAllDays', isAvailable === dayCheked ? true : ''))
                        }}
                      />
                      <label htmlFor={`reactivateDays[${index}]`}>{day.name}</label>
                      <br />
                    </div>)
                  })}
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type='button'
            className={`btn btn-default ${styles.btnCancel}`}
            onClick={this._onHide}>
            Cancel
          </button>
          <button
            type='button'
            className='btn btn-primary'
            onClick={this._onConfirm}
            disabled={isPristineForm}>
            Update
          </button>
        </div>
      </Modal.Footer>
    </Modal>)
  }

  _onHide = () => {
    this.props.dispatch(cancelReactivate())
  }

  _onConfirm = () => {
    let {reactivatedPromo, formValues, outlets, isManager, hashedPromoType, detailPromo} = this.props
    let hashedOutlets = mapKeys(outlets, 'id')
    const outletNames = []
    detailPromo.outlet_ids.forEach(oId => {
      if (hashedOutlets[oId]) {
        outletNames.push(hashedOutlets[oId].name)
      }
    })
    libraryPromoDeleteReactivateDeactivate('Promo Reactivate', {
      promoType: hashedPromoType[reactivatedPromo.promo_type_id].name,
      promoName: reactivatedPromo.name,
      outlet: outletNames
    })
    if (isManager) {
      this.props.dispatch(hideReactivateModal())
      this.props.dispatch(setActionUpdateName('reactivate'))
      this.props.dispatch(askConfirmationUpdate(
        reactivatePromo(
          reactivatedPromo,
          formValues,
          hashedOutlets
        )
      ))
    } else {
      this.props.dispatch(reactivatePromo(
        reactivatedPromo,
        formValues,
        hashedOutlets
      ))
    }
  }

  _onChangeDate = ({startDate, endDate}) => {
    this.props.dispatch(change('reactivateForm', 'date', {startDate, endDate}))
  }

  _isGreaterThanCurrentTime = (formValues) => {
    const {reactivatedPromo} = this.props
    const {startDate} = formValues.date
    return reactivatedPromo && moment(startDate).isSameOrAfter(moment().startOf('day').toISOString())
  }
}

const mapForm = {
  form: 'reactivateForm'
}

function mapStateToProps (state) {
  const {showReactivateModal, reactivatedPromo, detailPromo, outlets, promoTypes} = state.library.promo
  const {business} = state.moka.user
  const isManager = state.moka.user.is_manager
  const hashedPromoType = mapKeys(promoTypes, 'id')
  return {
    showReactivateModal,
    reactivatedPromo,
    formValues: getFormValues('reactivateForm')(state),
    business,
    isPristineForm: isPristine('reactivateForm')(state),
    detailPromo,
    outlets,
    isManager,
    hashedPromoType
  }
}

export default connect(mapStateToProps)(reduxForm(mapForm)(ReactivateModal))



// WEBPACK FOOTER //
// ./app/pages/Library/Promo/ReactivateModal/ReactivateModal.js